import { useSelector, useDispatch } from 'react-redux'
import { addReCaptcha } from '@store/ducks/simulate'
import getRecaptchaKey from '@client/services/recaptcha'

export default function useRecaptcha() {
  const dispatch = useDispatch()
  const contact = useSelector(store => store.simulate)

  async function setRecaptcha() {
    const recaptchaVersion = 'V3'
    const recaptchaAction = 'search_company_employee'

    const intervalId = setInterval(() => {
      if (global.grecaptcha !== undefined) {
        window.grecaptcha.ready(async () => {
          const { data: recaptchaKeyV3 } = await getRecaptchaKey()

          const recaptchaToken = await window.grecaptcha.execute(
            recaptchaKeyV3,
            {
              action: recaptchaAction,
            }
          )

          dispatch(
            addReCaptcha({
              recaptchaToken,
              recaptchaVersion,
              recaptchaAction,
            })
          )
        })

        clearInterval(intervalId)
      }
    }, 500)
  }

  async function resetRecaptcha() {
    if (contact && contact.recaptchaToken) {
      dispatch(
        addReCaptcha({
          recaptchaToken: null,
          recaptchaVersion: null,
          recaptchaAction: null,
        })
      )
    }
  }
  return {
    setRecaptcha,
    resetRecaptcha,
  }
}
